module.exports = __webpack_public_path__ + "img/categories-2.65954c7a.jpg";